// 更新分行
export const UPDATA_BANKLIST = 'UPDATA_BANKLIST';

export const FETCH_BANKLIST_BEGIN = 'FETCH_BANKLIST_BEGIN';
export const FETCH_BANKLIST_SUCCESS = 'FETCH_BANKLIST_SUCCESS';
export const FETCH_BANKLIST_ERROR = 'FETCH_BANKLIST_ERROR';

export const RESET_BANKLIST = 'RESET_BANKLIST';